/**
 * BÖLÜM BAŞLIĞI SÖZLEŞMESİ — TEK KAYNAK (web + mobil).
 *
 * Karar: `docs/design/tipografi/WarmBreak Tipografi - Bolum Basligi ve Ust
 * Etiket.SPEC.md` (Claude Design, 14.09.2026). Yeni bir tipografi KADEMESİ
 * eklenmedi; var olan bölüm başlığı yeniden tanımlandı:
 *
 *   ÖNCE   11/600 uppercase, üçüncül renk, üstünde 16 boşluk  → 4,6:1
 *   SONRA  24/600 serif, ana metin rengi, üstünde 32 + 2px ayırıcı → 13,9:1
 *
 * Asıl düzeltme boyutta değil AYIRIMDA: hiyerarşi ağırlık + renk + ayrımdan
 * kurulur (SPEC "Hiyerarşi nereden geldi").
 *
 * AYIRICI RENGİ — KARAR VE ÖLÇÜM (yapım turu TB1, kapanış kriteri 1).
 *
 * Tasarım `--color-neutral-400` (#BAB6B6) istiyor; depodaki en yakın token
 * `colors.borderStrong` (#CFCBC2) ve DAHA AÇIK. Karar: yeni bir nötr basamak
 * (`palette.neutral.lineStronger`) + rol tokenı (`colors.sectionDivider`).
 * Gerekçe ÖLÇÜLDÜ, göz kararı değil:
 *
 *   | ton                        | zemin üstü | yüzey üstü |
 *   | -------------------------- | ---------- | ---------- |
 *   | `borderStrong`  #CFCBC2    | 1,50:1     | 1,62:1     |
 *   | `sectionDivider` #BAB6B6   | 1,86:1     | 2,01:1     |
 *   | karanlık `dark.lineStrong` | 1,99:1     | 1,80:1     |
 *
 * `borderStrong` seçilseydi açık tema, karanlık temadan %33 SÖNÜK bir ayırıcı
 * çizerdi; yeni basamakla iki tema 0,14 içinde buluşur. İkinci gerekçe ROLDÜR:
 * `borderStrong` bu depoda DENETİM çerçevesidir (girdi, onay kutusu, ikincil
 * düğme, anahtar rayı — 20+ yüzey), bölüm ayırıcısı ise YAPI işaretidir ve
 * marka katmanı ikisini ayrı ayarlayabilmelidir. Karanlıkta AYRI basamak
 * açılmadı: `dark.lineStrong` zaten doğru bantta.
 * `section-heading.guard.spec` bu üç satırı iki yönlü asertler.
 *
 * ÜST ETİKET (`Kicker`) DEĞİŞMEDİ ve bu bilinçlidir: 11/600, 0.06em, uppercase,
 * üçüncül renk. Üst etiket ANLAM taşımaz BAĞLAM taşır; altında her zaman bir
 * başlık vardır. Kendi başına duran bir üst etiket bölüm başlığıdır ve yanlış
 * üsluptadır — `section-heading.guard.spec` bunu makineyle enumere eder.
 *
 * Ölçüler `spacing`/`typography` merdivenlerinden TÜRETİLİR, ikinci kez
 * yazılmaz; SPEC'in dört sayısı (32 · 2 · 16 · 12) merdivenin basamaklarına
 * birebir oturur.
 */
import { breakpoints } from './layout';
import { spacing, typography } from './tokens';
export const sectionHeading = {
    /** 24 — `typography.fontSize['2xl']`. Kırılımla DEĞİŞMEZ. */
    fontSize: typography.fontSize['2xl'],
    /** 600 — kırılımla DEĞİŞMEZ. */
    fontWeight: typography.fontWeight.semibold,
    /** Serif (`fontFamily.display`); listede/butonda/etikette kullanılmaz. */
    lineHeight: 1.2,
    letterSpacing: typography.letterSpacing.snug,
    /** Ayırıcı 2px — Görsel Dil v2'nin 1px saç çizgisinden BİLİNÇLİ olarak kalın. */
    dividerWidth: 2,
    /** Ayırıcı → başlık. */
    dividerGap: spacing.lg,
    /** Başlık → içerik. */
    contentGap: spacing.md,
    /** Bölümün üstündeki boşluk; `l` (1024+) kırılımında büyüyen TEK değer. */
    spaceBefore: {
        base: spacing['2xl'],
        l: spacing['3xl'],
    },
};
/**
 * Üst boşluk kırılımdan TÜRETİLİR (SPEC "Kırılım"): 375–1023 → 32 · 1024+ → 48.
 * Punto ve ağırlık burada YOKTUR çünkü kırılımla değişmezler — ikinci bir
 * ölçü seti doğmasın diye eşik `breakpoints.l`den okunur, elle yazılmaz.
 */
export function sectionSpaceBefore(width) {
    return width >= breakpoints.l ? sectionHeading.spaceBefore.l : sectionHeading.spaceBefore.base;
}
//# sourceMappingURL=section-heading.js.map